import React, { createContext, useContext } from 'react';

import { Theme } from './theme';
import { lightTheme } from './theme.light';

const ThemeContext = createContext<Theme>(null as unknown as Theme);

export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <ThemeContext.Provider value={lightTheme}>{children}</ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
